import { useRef, useState, useEffect,useContext } from "react";
import { Checkbox, Panel, DefaultButton, TextField, SpinButton, Dropdown, IDropdownOption, DropdownMenuItemType } from "@fluentui/react";
import { SparkleFilled } from "@fluentui/react-icons";
import logo_chat from "../../assets/logo_chat.png";
import format from "date-fns/format";
import uuid from 'react-uuid';
import styles from "./Chat.module.css";
import { ratingmodelState } from "../../api";
import { chatApi, Approaches, AskResponse, ChatRequest, ChatTurn } from "../../api";
import { Answer, AnswerError, AnswerLoading } from "../../components/Answer";
import { QuestionInput } from "../../components/QuestionInput";
import { ExampleList } from "../../components/Example";
import { UserChatMessage } from "../../components/UserChatMessage";
import { AnalysisPanel, AnalysisPanelTabs } from "../../components/AnalysisPanel";
import { SettingsButton } from "../../components/SettingsButton";
import { ClearChatButton } from "../../components/ClearChatButton";
import ModalLike from "../../components/Answer/Modal";
import { ModalDisLike } from "../../components/Answer/Modal";
import { AppStateContext } from "../../components/state/AppProvider";
import { ratingApi } from "../../components/api";
const Chat = () => {
    const appStateContext = useContext(AppStateContext)
    const [isConfigPanelOpen, setIsConfigPanelOpen] = useState(false);
    const [promptTemplate, setPromptTemplate] = useState<string>("");
    const [retrieveCount, setRetrieveCount] = useState<number>(10);
    const [useSemanticRanker, setUseSemanticRanker] = useState<boolean>(false);
    const [useSemanticCaptions, setUseSemanticCaptions] = useState<boolean>(false);
    const [excludeCategory, setExcludeCategory] = useState<string>("");
    const [modelSelection, setModel] = useState<string>("gpt35turbo");
    const [useSuggestFollowupQuestions, setUseSuggestFollowupQuestions] = useState<boolean>(false);
    const abortFuncs = useRef([] as AbortController[]);
    const lastQuestionRef = useRef<string>("");
    const chatMessageStreamEnd = useRef<HTMLDivElement | null>(null);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<unknown>();

    const [activeCitation, setActiveCitation] = useState<string>();
    const [activeAnalysisPanelTab, setActiveAnalysisPanelTab] = useState<AnalysisPanelTabs | undefined>(undefined);

    const [selectedAnswer, setSelectedAnswer] = useState<number>(0);
    const [answers, setAnswers] = useState<[user: string, response: AskResponse][]>([]);

    const [showLikeModal, setshowLikeModal] = useState<boolean>(false);
    const [showDislikeModal, setshowDislikeModal] = useState<boolean>(false);

    useEffect(() => {
        setshowLikeModal(appStateContext?.state.OpenLikeModal!);
        if(!appStateContext?.state.OpenLikeModal! && appStateContext?.state.MessageSelected != -1){
            const history: ChatTurn[] = answers.map(a => ({ user: a[0], bot: a[1].answer }));
            const currentDate = new Date();
            const formattedDate = format(currentDate, 'yyyyMMdd');
            const formattedTime = format(currentDate, 'HHmmss');
            const partitionkey = parseInt(format(currentDate, 'yyyyMM'));
            const anio = currentDate.getFullYear();;
            const mes = currentDate.getMonth() + 1;
            const idMensajeBuscado = appStateContext?.state.MessageSelected ?? 0; // Reemplaza 'id_del_mensaje_buscado' con el ID que estás buscando

            let respuesta = "";
            let preguntaUser = "";
            let respuestaAnterior = "";
            let preguntaUserAnterior = "";

            respuesta = history[idMensajeBuscado].bot ?? "";
            preguntaUser = history[idMensajeBuscado].user ?? "";
            if(idMensajeBuscado != 0){
            preguntaUserAnterior = history[idMensajeBuscado - 1].user ?? "";
            respuestaAnterior = history[idMensajeBuscado - 1].bot ?? "";
            }

          

            const ratings = {
                "PartitionKey": partitionkey,
                "flagRating": "True",
                "anio": anio,
                "mes": mes,
                "flagHarmfull": "False",
                "flagIsNotHelpfull": "False",
                "flagIsNotTrue": "False",
                "id": uuid(),
                "idConversacion": appStateContext?.state.currentChat?.id ?? "",
                "messages": {
                    "Coment": appStateContext?.state.Comment ?? "",
                    "date": formattedDate,
                    "hour": formattedTime,
                    "idRespuesta": idMensajeBuscado.toString(),
                    "preguntaUser": preguntaUser,
                    "preguntaUserAnterior": preguntaUserAnterior,
                    "respuesta": respuesta,
                    "respuestaAnterior": respuestaAnterior
                }  
            }
            console.log("Rating Model: ",ratings)
            appStateContext?.dispatch({type:'SET_Rating_MODEL',payload:ratings})
            makeRatingRequest(ratings);
        }
    },[appStateContext?.state.OpenLikeModal]);

    useEffect(() => {
        setshowDislikeModal(appStateContext?.state.OpenDislikeModal!);
        console.log("MODAL CHANGED");
        console.log(appStateContext?.state.OpenDislikeModal!);
        console.log(appStateContext?.state.MessageSelected);
        if(!appStateContext?.state.OpenDislikeModal! && appStateContext?.state.MessageSelected != -1){
            const history: ChatTurn[] = answers.map(a => ({ user: a[0], bot: a[1].answer }));
            console.log("Entered");
            const currentDate = new Date();
            const formattedDate = format(currentDate, 'yyyyMMdd');
            const formattedTime = format(currentDate, 'HHmmss');
            const partitionkey = parseInt(format(currentDate, 'yyyyMM'));
            const anio = currentDate.getFullYear();;
            const mes = currentDate.getMonth() + 1;
            // Supongamos que tienes un array de mensajes llamado 'mensajes'
            const idMensajeBuscado = appStateContext?.state.MessageSelected ?? 0; // Reemplaza 'id_del_mensaje_buscado' con el ID que estás buscando

            let respuesta = "";
            let preguntaUser = "";
            let respuestaAnterior = "";
            let preguntaUserAnterior = "";

            respuesta = history[idMensajeBuscado].bot ?? "";
            preguntaUser = history[idMensajeBuscado].user ?? "";
            if(idMensajeBuscado != 0){
            preguntaUserAnterior = history[idMensajeBuscado - 1].user ?? "";
            respuestaAnterior = history[idMensajeBuscado - 1].bot ?? "";
            }

            var flagHarmfull = "False";
            var flagIsNotTrue = "False";
            var flagIsNotHelpfull = "False";
            
            const checkedboxes = appStateContext?.state.Checkboxes ?? [false,false,false];

            if(checkedboxes[0]){
                flagHarmfull = "True";
            }
            if(checkedboxes[1]){
                flagIsNotTrue="True";
            }
            if(checkedboxes[2]){
                flagIsNotHelpfull="True";
            }

            const ratings = {
                "PartitionKey": partitionkey,
                "flagRating": "False",
                "anio": anio,
                "mes": mes,
                "flagHarmfull": flagHarmfull,
                "flagIsNotHelpfull": flagIsNotHelpfull,
                "flagIsNotTrue": flagIsNotTrue,
                "id": uuid(),
                "idConversacion": appStateContext?.state.currentChat?.id ?? "",
                "messages": {
                    "Coment": appStateContext?.state.Comment ?? "",
                    "date": formattedDate,
                    "hour": formattedTime,
                    "idRespuesta": idMensajeBuscado.toString(),
                    "preguntaUser": preguntaUser,
                    "preguntaUserAnterior": preguntaUserAnterior,
                    "respuesta": respuesta,
                    "respuestaAnterior": respuestaAnterior
                }  
            }
            console.log("Rating Model: ",ratings)
            appStateContext?.dispatch({type:'SET_Rating_MODEL',payload:ratings})
            makeRatingRequest(ratings);
        }
    },[appStateContext?.state.OpenDislikeModal]);

    const makeRatingRequest = async (rating: ratingmodelState) =>{
        const abortController = new AbortController();
        abortFuncs.current.unshift(abortController);
        
        try {
            const response = await ratingApi(rating, abortController.signal);
            console.log(response);
        } catch ( e )  {
            if (!abortController.signal.aborted) {
                let errorMessage = "Ocurrió un error. Inténtalo de nuevo. Si el problema persiste, comuníquese con el administrador del sitio.";
                console.log(errorMessage);
            } 
        } finally {
            abortFuncs.current = abortFuncs.current.filter(a => a !== abortController);
        }

        return abortController.abort();
    }

    const makeApiRequest = async (question: string) => {
        console.log("request");
        lastQuestionRef.current = question;

        error && setError(undefined);
        setIsLoading(true);
        setActiveCitation(undefined);
        setActiveAnalysisPanelTab(undefined);
        console.log("request");
        try {
            console.log("request");
            const history: ChatTurn[] = answers.map(a => ({ user: a[0], bot: a[1].answer }));
            console.log(history);
            const request: ChatRequest = {
                history: [...history, { user: question, bot: undefined }],
                approach: Approaches.ReadRetrieveRead,
                overrides: {
                    promptTemplate: promptTemplate.length === 0 ? undefined : promptTemplate,
                    excludeCategory: excludeCategory.length === 0 ? undefined : excludeCategory,
                    top: retrieveCount,
                    modelSelection: modelSelection,
                    semanticRanker: useSemanticRanker,
                    semanticCaptions: useSemanticCaptions,
                    suggestFollowupQuestions: useSuggestFollowupQuestions
                }
            };
            console.log(request);
            
            const result = await chatApi(request);
            console.log("Result openai");
            console.log(result);
            // const result: AskResponse = {
            //     answer:"Test adflkajsdglkajsdñgasñlkdjf",
            //     thoughts:null,
            //     data_points: [],
            //     id:"1"
            // }
            setAnswers([...answers, [question, result]]);
        } catch (e) {
            setError(e);
        } finally {
            setIsLoading(false);
        }
    };

    const clearChat = () => {
        lastQuestionRef.current = "";
        error && setError(undefined);
        setActiveCitation(undefined);
        setActiveAnalysisPanelTab(undefined);
        setAnswers([]);
    };

    useEffect(() => chatMessageStreamEnd.current?.scrollIntoView({ behavior: "smooth" }), [isLoading]);

    const onPromptTemplateChange = (_ev?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        setPromptTemplate(newValue || "");
    };

    const onRetrieveCountChange = (_ev?: React.SyntheticEvent<HTMLElement, Event>, newValue?: string) => {
        setRetrieveCount(parseInt(newValue || "3"));
    };

    const onUseSemanticRankerChange = (_ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        setUseSemanticRanker(!!checked);
    };

    const onUseSemanticCaptionsChange = (_ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        setUseSemanticCaptions(!!checked);
    };

    const onExcludeCategoryChanged = (_ev?: React.FormEvent, newValue?: string) => {
        setExcludeCategory(newValue || "");
    };

    const onModelSelection = (_ev?: React.FormEvent, selection?: IDropdownOption) => {
        if (selection) {
            setModel(selection.key.toString() || "gpt35turbo");
        } else {
            const defaultValue: string = "gpt35turbo";
            setModel(defaultValue || "gpt35turbo");
        }
    };

    const onUseSuggestFollowupQuestionsChange = (_ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        setUseSuggestFollowupQuestions(!!checked);
    };

    const onExampleClicked = (example: string) => {
        makeApiRequest(example);
    };

    const onShowCitation = (citation: string, index: number) => {
        if (activeCitation === citation && activeAnalysisPanelTab === AnalysisPanelTabs.CitationTab && selectedAnswer === index) {
            setActiveAnalysisPanelTab(undefined);
        } else {
            setActiveCitation(citation);
            setActiveAnalysisPanelTab(AnalysisPanelTabs.CitationTab);
        }

        setSelectedAnswer(index);
    };

    const onToggleTab = (tab: AnalysisPanelTabs, index: number) => {
        if (activeAnalysisPanelTab === tab && selectedAnswer === index) {
            setActiveAnalysisPanelTab(undefined);
        } else {
            setActiveAnalysisPanelTab(tab);
        }

        setSelectedAnswer(index);
    };

    const options: IDropdownOption[] = [
        { key: "GPT 3", text: "GPT 3", itemType: DropdownMenuItemType.Header },
        { key: "gpt35turbo", text: "GPT3.5 TURBO" },
        { key: "divider_1", text: "-", itemType: DropdownMenuItemType.Divider },
        { key: "GPT 4", text: "GPT 4", itemType: DropdownMenuItemType.Header },
        { key: "gpt4", text: "GPT 4 - 8000 Tokens" },
        { key: "gpt4-32k", text: "GPT 4 - 32000 Tokens" }
    ];

    return (
        <>
        <div className={styles.container}>
            <div className={styles.commandsContainer}>
                <ClearChatButton className={styles.commandButton} onClick={clearChat} disabled={!lastQuestionRef.current || isLoading} />
                {/* <SettingsButton className={styles.commandButton} onClick={() => setIsConfigPanelOpen(!isConfigPanelOpen)} /> */}
            </div>
            <div className={styles.chatRoot}>
                <div className={styles.chatContainer}>
                    {!lastQuestionRef.current ? (
                        <div className={styles.chatEmptyState}>
                            <h1 className={styles.chatEmptyStateTitle}>IAction Instruccional</h1>
                            <h2 className={styles.chatEmptyStateSubtitle}>Diseño de experiencias de aprendizajes efectivas en línea.</h2>
                            <ExampleList onExampleClicked={onExampleClicked} />
                        </div>
                    ) : (
                        <div className={styles.chatMessageStream}>
                            {answers.map((answer, index) => (
                                <div key={index}>
                                    <UserChatMessage message={answer[0]} />
                                    <div className={styles.chatMessageGpt}>
                                        <Answer
                                            id = {index}
                                            key={index}
                                            answer={answer[1]}
                                            isSelected={selectedAnswer === index && activeAnalysisPanelTab !== undefined}
                                            onCitationClicked={c => onShowCitation(c, index)}
                                            onThoughtProcessClicked={() => onToggleTab(AnalysisPanelTabs.ThoughtProcessTab, index)}
                                            onSupportingContentClicked={() => onToggleTab(AnalysisPanelTabs.SupportingContentTab, index)}
                                            onFollowupQuestionClicked={q => makeApiRequest(q)}
                                            showFollowupQuestions={useSuggestFollowupQuestions && answers.length - 1 === index}
                                        />
                                    </div>
                                </div>
                            ))}
                            {isLoading && (
                                <>
                                    <UserChatMessage message={lastQuestionRef.current} />
                                    <div className={styles.chatMessageGptMinWidth}>
                                        <AnswerLoading />
                                    </div>
                                </>
                            )}
                            {error ? (
                                <>
                                    <UserChatMessage message={lastQuestionRef.current} />
                                    <div className={styles.chatMessageGptMinWidth}>
                                        <AnswerError error={error.toString()} onRetry={() => makeApiRequest(lastQuestionRef.current)} />
                                    </div>
                                </>
                            ) : null}
                            <div ref={chatMessageStreamEnd} />
                        </div>
                    )}

                    <div className={styles.chatInput}>
                        <QuestionInput
                            clearOnSend
                            placeholder="¡Hola! Soy IAction Instruccional. Estoy aquí para ayudarte a diseñar experiencias de aprendizajes. ¿En qué puedo apoyarte hoy?"
                            disabled={isLoading}
                            onSend={question => makeApiRequest(question)}
                        />
                    </div>
                </div>

                {answers.length > 0 && activeAnalysisPanelTab && (
                    <AnalysisPanel
                        className={styles.chatAnalysisPanel}
                        activeCitation={activeCitation}
                        onActiveTabChanged={x => onToggleTab(x, selectedAnswer)}
                        citationHeight="810px"
                        answer={answers[selectedAnswer][1]}
                        activeTab={activeAnalysisPanelTab}
                    />
                )}

                <Panel
                    headerText="Configure answer generation"
                    isOpen={isConfigPanelOpen}
                    isBlocking={false}
                    onDismiss={() => setIsConfigPanelOpen(false)}
                    closeButtonAriaLabel="Close"
                    onRenderFooterContent={() => <DefaultButton onClick={() => setIsConfigPanelOpen(false)}>Close</DefaultButton>}
                    isFooterAtBottom={true}
                >
                    <TextField
                        className={styles.chatSettingsSeparator}
                        defaultValue={promptTemplate}
                        label="Override prompt template"
                        multiline
                        autoAdjustHeight
                        onChange={onPromptTemplateChange}
                    />

                    <SpinButton
                        className={styles.chatSettingsSeparator}
                        label="Retrieve this many documents from search:"
                        min={1}
                        max={50}
                        defaultValue={retrieveCount.toString()}
                        onChange={onRetrieveCountChange}
                    />
                    <TextField className={styles.chatSettingsSeparator} label="Exclude category" onChange={onExcludeCategoryChanged} />
                    <Checkbox
                        className={styles.chatSettingsSeparator}
                        checked={useSemanticRanker}
                        label="Use semantic ranker for retrieval"
                        onChange={onUseSemanticRankerChange}
                    />
                    <Checkbox
                        className={styles.chatSettingsSeparator}
                        checked={useSemanticCaptions}
                        label="Use query-contextual summaries instead of whole documents"
                        onChange={onUseSemanticCaptionsChange}
                        disabled={!useSemanticRanker}
                    />
                    <Checkbox
                        className={styles.chatSettingsSeparator}
                        checked={useSuggestFollowupQuestions}
                        label="Suggest follow-up questions"
                        onChange={onUseSuggestFollowupQuestionsChange}
                    />
                    <Dropdown
                        className={styles.chatSettingsSeparator}
                        label="Model"
                        options={options}
                        defaultSelectedKey={modelSelection}
                        onChange={onModelSelection}
                    />
                </Panel>
            </div>
        </div>
        {showLikeModal ? ( <ModalLike></ModalLike>):(<></>)}
        {showDislikeModal ? ( <ModalDisLike></ModalDisLike>):(<></>)}
        </>
    );
};

export default Chat;
